import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2V22H2V2H22ZM6.65692 13.3719L18.3719 6.34292L17.3429 4.62793L9.45531 9.36049L7.38843 5.64012L5.64012 6.6114L7.73937 10.3901L5.62793 11.6569L6.65692 13.3719ZM16.2605 13.6098L18.3719 12.3429L17.3429 10.6279L5.62793 17.6569L6.65692 19.3719L14.5445 14.6393L16.6114 18.3597L18.3597 17.3884L16.2605 13.6098Z"}}]};

const StreetRoadFilled = Vue.extend<IconProps>({
  name: 'StreetRoadFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'street-road-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default StreetRoadFilled;
